import { ReactNode, forwardRef, ForwardRefRenderFunction } from 'react';

import ErrorIcon from '@mui/icons-material/Error';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import { useConfirm, UseConfirmProps } from 'lib';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

type Props = IconButtonProps &
  UseConfirmProps & {
    children: ReactNode;
    confirmText?: ReactNode;
    confirmIcon?: ReactNode;
  };

type ComponentType = ForwardRefRenderFunction<any, Props>;

const ConfirmableIconButton: ComponentType = (props, ref) => {
  const {
    children,
    confirmIcon = <ErrorIcon fontSize="small" />,
    confirmText,
    enabled,
    onConfirm,
    ...rest
  } = props;

  const { confirming, ...confirm } = useConfirm({ enabled, onConfirm });

  return (
    <Box
      sx={{ position: 'relative', display: 'inline-block', minWidth: '30px' }}>
      {confirmText && confirming ? (
        <Button
          {...confirm}
          color="error"
          variant="contained"
          size="small"
          startIcon={confirmIcon}
          sx={{
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translate(0, calc(-50% - 2px))',
            zIndex: 1000,
          }}>
          {confirmText}
        </Button>
      ) : (
        <IconButton
          color="error"
          size="small"
          sx={{ minWidth: 20 }}
          ref={ref}
          {...rest}
          {...confirm}>
          {confirming ? confirmIcon : children}
        </IconButton>
      )}
    </Box>
  );
};

export default forwardRef(ConfirmableIconButton);
